<template>
  <div class="container-fluid">
    <div
      class="mt-4 page-header min-height-250 border-radius-xl"
      :style="{
        backgroundImage: 'url(' + require('@/assets/img/curved-images/curved14.jpg') + ')',
        backgroundPositionY: '10%',
      }"
    >
      <span
        class="mask opacity-5"
        style="background-color: rgb(44, 222, 44)"
      ></span>
      <div style="display: flex; align-items: center; justify-content: center">
        <div style="position: absolute; left: 50%; transform: translateX(-50%); top: 30%">
          <h3 style="color: rgb(255, 255, 255); text-align: center">{{ $t("Visits for Line") }}</h3>
          <h5 style="color: rgb(255, 255, 255); text-align: center">{{ line.name }}</h5>
        </div>
      </div>
    </div>
    <div class="mx-4 mt-n6 overflow-hidden card card-body blur shadow-blur">
      <div class="row gx-4">
        <div class="row text-center">
          <div
            class="col p-3"
            style="min-width: 100px; height: 150px"
          >
            <button
              class="w-60px mt-2 mb-0 btn ms-lg-auto me-lg-0 me-auto mt-lg-0"
              type="button"
              style="width: 200px; height: 100px; background-color: rgb(231, 245, 221); font-size: 0.9rem"
              @click="createNewVisit"
            >
              {{ $t("New Visit") }}
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div
              class="table-responsive"
              style="margin: 0px"
            >
              <table
                id="order-list"
                class="table table-flush"
              >
                <thead class="thead-light">
                  <tr>
                    <th class="text-center">Date</th>
                    <th class="text-center">Powder Name</th>
                    <th class="text-center">Benchmark &amp; Target</th>
                    <th class="text-center">Health Check</th>
                    <th class="text-center">Guns Equalization</th>
                    <th class="text-center">Spray Pattern</th>
                    <th class="text-center">Reciprocator Optimization</th>
                    <th class="text-center">Thickness Adjustment</th>
                    <th class="text-center"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="visit in visitsList"
                    :key="visit.date"
                  >
                    <visit-row
                      :date-time="visit ? dateToString(visit.created_at, true) : dateToString(new Date(), true)"
                      :powder-name="visit.benchmarkstage.powder ? visit.benchmarkstage.powder.name : '-'"
                      :benchmark-checked="visit.benchmarkstage ? visit.benchmarkstage.progress_status : 'Pending'"
                      :health-checked="visit.healthcheckstage ? visit.healthcheckstage.progress_status : 'Pending'"
                      :guns-equalization-checked="
                        visit.gunsequalizationstage ? visit.gunsequalizationstage.progress_status : 'Pending'"
                      :spray-pattern-checked="
                        visit.spraypatternstage ? visit.spraypatternstage.progress_status : 'Pending'"
                      :reciprocator-checked="
                        visit.reciprocatorstage ? visit.reciprocatorstage.progress_status : 'Pending'"
                      :thickness-adjustment-checked="
                        visit.thicknessadjustmentstage ? visit.thicknessadjustmentstage.progress_status : 'Pending'"
                      :finalized-at-stage="visit.finalized_at_stage"
                      :line-id="lineId"
                      :visit-id="visit.id"
                      @delete-visit="(visit_id, datetime) => deleteVisit(visit_id, datetime)"
                    ></visit-row>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mx-auto col-12 button-row text-center mt-3">
      <button
        type="button"
        class="me-auto btn btn-dark w-60 ml-3 mb-0"
        style="max-width: 60%"
        @click="handleShareLineClick"
      >
        Share Line with FineTune user
      </button>
      <div
        id="modal-form"
        ref="modal"
        class="modal fade"
        tabindex="-1"
        role="dialog"
        aria-labelledby="modal-form"
        aria-hidden="true"
        style="z-index: 1900 !important"
      >
        <div
          class="modal-dialog modal-dialog-centered modal-md"
          role="document"
        >
          <div
            class="modal-content"
            style="text-align: left !important"
          >
            <div class="modal-body p-0">
              <div class="card card-plain">
                <div class="card-body justify-content-left">
                <button
                  ref="dismissButton"
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  style="
                    color: black;
                    position: absolute;
                    top: 0;
                    right: 0;
                    z-index: 99999 !important;
                    margin: 10px;
                    padding: 5px;
                  "
                >
                  <font-awesome-icon :icon="['fas', 'xmark']" />
                </button>
                  <form
                    role="form"
                    class=""
                  >
                    <div v-if="showShareLineSpinner" class="text-center">
                      <div class="spinner-border text-success" role="status">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                    </div>
                    <div v-else>
                      <h5 class="mb-0">Share Line</h5>
                      <p class="mt-0 mb-0"> Share Line with existing FineTune user</p>
                      <p class="mt-0 mb-0"> or create new FineTune user and share</p>
                      <label>User email</label>
                      <div class="input-group">
                        <input
                          v-model="finetune_user_email"
                          type="text"
                          :class="finetune_user_email_input_error ? `form-control is-invalid` : `form-control`"
                          placeholder="user@company.com"
                          @input="finetune_user_email_input_error = false; showInvalidEmailFormatErrorLabel = false; showEmptyEmailErrorLabel = false;"
                        />
                      </div>
                      <small v-if="showInvalidEmailFormatErrorLabel" class="text-danger mt-0 mb-2">
                        Please enter a valid email address.
                        <br/>
                      </small>
                      <small v-if="showEmptyEmailErrorLabel" class="text-danger mt-0 mb-2">
                        Please enter an email address.
                        <br/>
                      </small>
                      <label>User or company name</label>
                      <p class="text-xs form-text text-muted ms-1 d-inline">(Optional)</p>
                      <div class="input-group mb-3">
                        <input
                          v-model="finetune_user_name"
                          type="text"
                          :class="finetune_user_name_input_error ? `form-control is-invalid` : `form-control`"
                          placeholder="User or company name"
                          @input="finetune_user_name_input_error = false"
                        />
                      </div>
                      <div class="text-center">
                        <button
                          type="button"
                          class="btn bg-gradient-success btn-lg w-100 mt-4 mb-0"
                          @click="shareLineWithFineTuneUser()"
                        >
                          Share line "{{ line.name }}"
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { dateToString, useGetLine, validateEmail } from "@/views/composables.js";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { Modal } from 'bootstrap';
import axios from "axios";
import setTooltip from "@/assets/js/tooltip.js";
import VisitRow from "../components/VisitRow.vue";

library.add(faXmark);

export default {
  name: "LineVisits",
  components: {
    FontAwesomeIcon,
    VisitRow,
  },
  props: {
    lineId: {
      type: String,
      default: "",
    },
  },
  setup() {
    const { line, getLine } = useGetLine();
    return { line, getLine };
  },
  data() {
    this.$i18n.locale = this.$store.state.user_data.language;
    return {
      finetune_user_email: null,
      finetune_user_name: null,
      finetune_user_email_input_error: false,
      finetune_user_name_input_error: false,
      visitsList: [],
      showShareLineSpinner: false,
      showEmptyEmailErrorLabel: false,
      showInvalidEmailFormatErrorLabel: false,
    };
  },
  computed: {},
  watch: {
    "$store.state.user_data.language"() {
      this.$i18n.locale = this.$store.state.user_data.language;
    },
  },
  mounted() {
    this.$store.state.isAbsolute = true;
    setTooltip();
    this.getData();
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
  },
  methods: {
    dateToString,
    validateEmail,
    async getData() {
      await Promise.all([this.getLine(this.lineId), this.getLineVisits()]);
    },
    async getLineVisits() {
      if (this.lineId) {
        try {
          let response = await axios.get("/api/v1/blueprint/visits/" + this.lineId);
          this.visitsList = response.data;
          this.visitsList.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        } catch (error) {
          console.error(error);
        }
      }
    },
    createNewVisit() {
      if (this.lineId) {
        try {
          axios
            .post("/api/v1/blueprint/visits/", {
              line: this.lineId,
            })
            .then(() => {
              this.getLineVisits();
            })
            .catch(error => {
              console.error(error);
            });
        } catch (error) {
          console.error(error);
        }
      }
    },
    deleteVisit(visitId, dateTime) {
      this.$swal({
        title: `Are you sure you want to delete Visit from ${dateTime}?`,
        text: "You will not be able to revert this!",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it",
        cancelButtonText: "No, cancel",
        reverseButtons: true,
        customClass: {
          confirmButton: "btn bg-gradient-success",
          cancelButton: "btn bg-gradient-danger",
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.isConfirmed) {
          this.$store.state.isLoading = true;
          axios
            .delete("/api/v1/blueprint/visit/" + visitId)
            .then(() => {
              this.$store.state.isLoading = false;
              this.$swal({
                title: "Deleted",
                text: `Visit from ${dateTime} has been deleted.`,
                icon: "success",
                customClass: {
                  confirmButton: "btn bg-gradient-success",
                },
                buttonsStyling: false,
              }).then(() => {
                this.getLineVisits();
              });
            })
            .catch(error => {
              console.error(error);
            });
        }
      });
    },
    async shareLineWithFineTuneUser() {
      if (!this.validShareLineForm()) {
        return;
      }

      try {
        this.showShareLineSpinner = true;
        const response = await axios.post("/api/v1/blueprint/sharelinetofinetuneapp/", {
          line_id: this.lineId,
          email: this.finetune_user_email,
          name: this.finetune_user_name,
        });

        this.showShareLineSpinner = false;
        this.closeModal();
        this.clearShareLineForm();

        await this.getData(this.lineId);

        this.$swal({
          title: "Line shared successfully",
          text: response.data.message,
          icon: "success",
          customClass: {
            confirmButton: "btn bg-gradient-success",
          },
          buttonsStyling: false,
        })
      } catch (error) {
        console.error(error);
        this.showShareLineSpinner = false;
        this.closeModal();
        this.clearShareLineForm();

        this.$swal({
          title: "Line sharing error",
          text: error.response.data.error,
          icon: "error",
          customClass: {
            confirmButton: "btn bg-gradient-success",
          },
          buttonsStyling: false,
        });
      }
    },
    handleShareLineClick() {
      if (this.checkIfLineCanBeShared()) {
        this.clearShareLineForm();
        const modal = new Modal(this.$refs.modal);
        modal.show();
      }
    },
    checkIfLineCanBeShared() {
      if (!this.visitsList.length) {
        this.$swal({
          title: "Line sharing error",
          text: "You can't share a line without any visits.",
          icon: "error",
          customClass: {
            confirmButton: "btn bg-gradient-success",
          },
          buttonsStyling: false,
        });
        return false;
      } else if (
        !this.visitsList.some(
          visit =>
        visit.benchmarkstage.progress_status === "Completed" &&
        visit.gunsequalizationstage.progress_status === "Completed"
        )
      ) {
        this.$swal({
          title: "Line sharing error",
          text: "You can't share a line without completing Benchmark & Target stage and Guns Equalization stage.",
          icon: "error",
          customClass: {
        confirmButton: "btn bg-gradient-success",
          },
          buttonsStyling: false,
        });
        return false;
      }
      return true;
    },
    clearShareLineForm() {
      this.finetune_user_email = null;
      this.finetune_user_name = null;
      this.showShareLineSpinner = false;
      this.showEmptyEmailErrorLabel = false;
      this.showInvalidEmailFormatErrorLabel = false;
    },
    validShareLineForm() {
      if (this.finetune_user_email == null || this.finetune_user_email == "") {
        this.showEmptyEmailErrorLabel = true;
        this.finetune_user_email_input_error = true;
        return false;
      }
      else if (!validateEmail(this.finetune_user_email)) {
        this.showInvalidEmailFormatErrorLabel = true;
        this.finetune_user_email_input_error = true;
        return false;
      }

      return true;
    },
    closeModal() {
      const dismissButton = this.$refs.dismissButton;
      if (dismissButton) {
        dismissButton.click();
      }
    },
  },
};
</script>

<i18n>
  {
    "EN": {
      "Visits for Line": "Visits for Line",
      "New Visit": "New Visit",
    },
    "DE": {
      "Visits for Line": "Visits for Line",
      "New Visit": "New Visit",
    },
    "ES": {
      "Visits for Line": "Visits for Line",
      "New Visit": "New Visit",
    },
    "FR": {
      "Visits for Line": "Visits for Line",
      "New Visit": "New Visit",
    },
    "IT": {
      "Visits for Line": "Visits for Line",
      "New Visit": "New Visit",
    },
    "PL": {
      "Visits for Line": "Visits for Line",
      "New Visit": "New Visit",
    },
    "TR": {
      "Visits for Line": "Visits for Line",
      "New Visit": "New Visit",
    },
    "ZH": {
      "Visits for Line": "Visits for Line",
      "New Visit": "New Visit",
    }
  }
</i18n>
